import React from 'react'
import styled from 'react-emotion'
import { ga, ProgressiveImage } from '../../application'
import Ascendant from './Ascendant'
import Concept from './Concept'

const HotelCard = styled('a')`
  border-radius: 4px;
  overflow: hidden;
  border: 0;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  width: calc(25% - 20px);
  margin: 0 10px 12px;
  .cux-hotel-info .wrapup {
    font-size: 1.2rem;
  }
  @media (max-width: 992px) {
    width: calc(50% - 20px);
  }
  @media (max-width: 767px) {
    margin: 10px;
    .cux-hotel-info .info p:not(.crumb),
    .facts,
    .customer-rating span {
      display: none;
    }
    .cux-hotel-info {
      padding: 5px;
    }
  }
`

const CustomerRating = ({ customerRating }) =>
  customerRating && (customerRating.name || (customerRating.generalImpression && customerRating.generalImpression.name)) ? (
    <div className="customer-rating">
      <span>{customerRating.name || customerRating.generalImpression.name}</span>&nbsp;
      <strong>{customerRating.score || customerRating.generalImpression.score}/10</strong>
    </div>
  ) : (
    <div></div>
  )

export default ({ hotel, children, context }) => {
  if (!hotel) return null

  const image = hotel.image.url || hotel.image
  const src = image ? `${image}?crop=edges&fit=crop` : '//cdn.tuinordic.com/img/fallback/fallback-480x320.jpg?fit=crop 560w'

  const concept = hotel.concept || (hotel.concepts && hotel.concepts.length > 0 ? hotel.concepts[0] : null)

  return (
    <HotelCard href={hotel.siteUrl} onClick={() => ga.buttonClick(`hotel-card-${context}`)} className="cux-hotel-card tui-card">
      <Concept concept={concept} hotel={hotel.id} />
      <div className="ratio-16-9">
        {children}
        <ProgressiveImage alt={hotel.name} src={src} imageParams="w=640" />
      </div>
      <div className="cux-hotel-info">
        <div className="info">
          <h3>
            {hotel.name} <span className="rating">{hotel.classification.name}</span>
          </h3>
          <p className="crumb">
            {hotel.country ? <span>{hotel.country}</span> : <Ascendant {...{ ...hotel, type: 'country' }} />}
            &nbsp;&rsaquo;&nbsp;
            {hotel.resort ? <span>{hotel.resort}</span> : <Ascendant {...{ ...hotel, type: 'resort' }} />}
          </p>
          <p>{hotel.usp}</p>
        </div>
        <div className="wrapup">
          <CustomerRating {...hotel} />
        </div>
      </div>
    </HotelCard>
  )
}
